const RELEASE_TAG = /^v(\d+)\.(\d+)\.(\d+)/;
const MAX_MINOR_OR_PATCH = 99;

export interface WebVersion {
    /** The shell's `versionCode` with its rebuild slot at 0. */
    code: number;
    name?: string;
}

/**
 * Reads `VITE_VERSION` (`git describe --tags --always`) as an integer a Mixpanel rule can compare
 * exactly. A prerelease or branch build counts as the tag it starts from; anything else reads as 0.
 */
export function parseWebVersion(describe: string | undefined): WebVersion {
    const match = describe?.match(RELEASE_TAG);
    if (!match) {
        return { code: 0 };
    }
    const [major, minor, patch] = match.slice(1).map(Number);
    if (minor > MAX_MINOR_OR_PATCH || patch > MAX_MINOR_OR_PATCH) {
        throw new Error(`Version '${describe}': minor and patch must each be 0 to 99`);
    }
    return {
        code: major * 1_000_000 + minor * 10_000 + patch * 100,
        name: `${major}.${minor}.${patch}`,
    };
}
